"use strict";

import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import aes from "aes-js";
import { getAddress } from "@ethersproject/address";
import { arrayify } from "@ethersproject/bytes";
import { keccak256 } from "@ethersproject/keccak256";
import { pbkdf2 } from "@ethersproject/pbkdf2";
import { toUtf8Bytes } from "@ethersproject/strings";
import { Description } from "@ethersproject/properties";
import { Logger } from "@ethersproject/logger";
import { version } from "./_version";
var logger = new Logger(version);
import { getPassword, looseArrayify, searchPath } from "./utils";
export var CrowdsaleAccount = /*#__PURE__*/function (_Description) {
  _inherits(CrowdsaleAccount, _Description);

  var _super = _createSuper(CrowdsaleAccount);

  function CrowdsaleAccount() {
    _classCallCheck(this, CrowdsaleAccount);

    return _super.apply(this, arguments);
  }

  _createClass(CrowdsaleAccount, [{
    key: "isCrowdsaleAccount",
    value: function isCrowdsaleAccount(value) {
      return !!(value && value._isCrowdsaleAccount);
    }
  }]);

  return CrowdsaleAccount;
}(Description); // See: https://github.com/ethereum/pyethsaletool

export function decrypt(json, password) {
  var data = JSON.parse(json);
  password = getPassword(password); // Ethereum Address

  var ethaddr = getAddress(searchPath(data, "ethaddr")); // Encrypted Seed

  var encseed = looseArrayify(searchPath(data, "encseed"));

  if (!encseed || encseed.length % 16 !== 0) {
    logger.throwArgumentError("invalid encseed", "json", json);
  }

  var key = arrayify(pbkdf2(password, password, 2000, 32, "sha256")).slice(0, 16);
  var iv = encseed.slice(0, 16);
  var encryptedSeed = encseed.slice(16); // Decrypt the seed

  var aesCbc = new aes.ModeOfOperation.cbc(key, iv);
  var seed = aes.padding.pkcs7.strip(arrayify(aesCbc.decrypt(encryptedSeed))); // This wallet format is weird... Convert the binary encoded hex to a string.

  var seedHex = "";

  for (var i = 0; i < seed.length; i++) {
    seedHex += String.fromCharCode(seed[i]);
  }

  var seedHexBytes = toUtf8Bytes(seedHex);
  var privateKey = keccak256(seedHexBytes);
  return new CrowdsaleAccount({
    _isCrowdsaleAccount: true,
    address: ethaddr,
    privateKey: privateKey
  });
}